import React from "react";
import { useNavigate,useLocation } from "react-router-dom";



const EventCards = () => {
  const location = useLocation();
  const events= location?.state;

  

  const navigate= useNavigate();
  
  const navigateBack=()=>{
      navigate(-1);
  }
  const navigateCard = (event) => {
    navigate("/Events", {
      state: {
        Events: event,
        from: location.pathname,
      },
    });
  };
   
  return (
    <div className="">
       
        <div>
  {events?.Event?.length > 0 ? (
    <div className="row g-4 d-flex">
      {events.Event.map((event) => (
        <div key={event.id} className="col-md-4" onClick={() => navigateCard(event)}>
          <div className="card event-card border-0 shadow-sm">
            <img
              src={event.file_url.replace("/thumb", "")}
              className="card-img-top h-15"
              alt={event.file_url}
              loading="lazy" 
            />
            <div className="card-body text-center">
              <h5 className="card-title fw-bold">{event.Event_Name}</h5>
              <p className="card-text text-muted">{event.Location?.split(":")[1]} {event.timeZone}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <h5 className="text-center text-muted">No events found</h5>
  )}
</div>

    </div>
  );
};

export default EventCards;
